module.exports = __webpack_public_path__ + "static/media/arrowdown-white.743afeef.svg";